module.exports = "<span class='items-counter' title='Počet {{items}} v tabulce'><b>{{itemsCount}}</b> {{items}}</span>"